import React, { useContext } from "react";
import { SignupInfoContext } from "../../contexts/SignupInfoContext";

const Radio = () => {
  const { info, setInfo } = useContext(SignupInfoContext);

  return (
    <>
      <h1 className="mb-3 font-medium text-gray-800">Are you:</h1>
      <section className="flex items-center space-x-4">
        <div className="flex items-center  mb-3">
          <input
            id="radio1"
            type="radio"
            name="radio"
            className="hidden"
            defaultChecked
          />
          <label htmlFor="radio1" className="flex items-center cursor-pointer ">
            <span
              className="w-6 h-6 inline-block mr-2 rounded-full border border-grey flex-no-shrink"
              onClick={() => setInfo({ ...info, isSalary: true })}
            ></span>
            Salaried
          </label>
        </div>

        <div className="flex items-center  mb-3">
          <input id="radio2" type="radio" name="radio" className="hidden" />
          <label htmlFor="radio2" className="flex items-center cursor-pointer">
            <span
              className="w-6 h-6 inline-block mr-2 rounded-full border border-grey flex-no-shrink"
              onClick={() => setInfo({ ...info, isSalary: false })}
            ></span>
            Non-Salaried
          </label>
        </div>
      </section>
    </>
  );
};

export default Radio;
